module.exports = __webpack_public_path__ + "img/binance-logo.1d68036d.webp";